import { formatDate, formatDateNoHour } from '../utilities/generalUtils'

class UserSettings {
    constructor(data = {}) {
        this.topUpAmount = data.topUpAmount || 0
        this.topUpTriggerAmount = data.topUpTriggerAmount || 0
        this.milesPerWeek = data.milesPerWeek || 0
        this.idTag = data.idTag || ''
        this.initialSetupComplete = data.initialSetupComplete || false
        this.access = this._initializeAccess(data.access || {})
    }

    _initializeAccess(accessData) {
        return {
            charging: this._initializeChargingAccess(accessData.charging || {})
        }
    }

    _initializeChargingAccess(chargingData) {
        return {
            reserved: this._initializeAccessType(chargingData.reserved || {}),
            shared: this._initializeAccessType(chargingData.shared || {})
        }
    }

    _initializeAccessType(accessTypeData) {
        return {
            allowed: accessTypeData.allowed || false,
            appliesTo: accessTypeData.appliesTo || [],
            state: accessTypeData.state || '',
            reason: accessTypeData.reason || '',
            expiresAt: accessTypeData.expiresAt || null
        }
    }

    static fromJSON(json) {
        return new UserSettings(json)
    }

    hasReservedChargingAccess() {
        return this.access.charging.reserved.allowed
    }

    hasSharedChargingAccess() {
        return this.access.charging.shared.allowed
    }

    hasAnyChargingAccess() {
        return this.hasReservedChargingAccess() || this.hasSharedChargingAccess()
    }

    getReservedChargingState() {
        return this.access.charging.reserved.state
    }

    getSharedChargingState() {
        return this.access.charging.shared.state
    }

    getReservedChargingReason() {
        return this.access.charging.reserved.reason
    }

    getSharedChargingReason() {
        return this.access.charging.shared.reason
    }

    getReservedChargingExpiry() {
        return this.access.charging.reserved.expiresAt
    }

    getSharedChargingExpiry() {
        return this.access.charging.shared.expiresAt
    }

    isSharedChargingExpired() {
        if (!this.access.charging.shared.expiresAt) return false
        return new Date(this.access.charging.shared.expiresAt) < new Date()
    }

    isReservedChargingExpired() {
        if (!this.access.charging.reserved.expiresAt) return false
        return new Date(this.access.charging.reserved.expiresAt) < new Date()
    }

    getFormattedSharedChargingExpiry() {
        return formatDate(this.access.charging.shared.expiresAt)
    }

    getFormattedReservedChargingExpiry() {
        return formatDate(this.access.charging.reserved.expiresAt)
    }

    getFormattedSharedChargingExpiryDateOnly() {
        return formatDateNoHour(this.access.charging.shared.expiresAt)
    }

    getFormattedReservedChargingExpiryDateOnly() {
        return formatDateNoHour(this.access.charging.reserved.expiresAt)
    }

    getReservedChargingDevices() {
        return this.access.charging.reserved.appliesTo
    }

    getSharedChargingDevices() {
        return this.access.charging.shared.appliesTo
    }

    isInitialSetupComplete() {
        return this.initialSetupComplete
    }

    toJSON() {
        return {
            topUpAmount: this.topUpAmount,
            topUpTriggerAmount: this.topUpTriggerAmount,
            milesPerWeek: this.milesPerWeek,
            idTag: this.idTag,
            initialSetupComplete: this.initialSetupComplete,
            access: this.access
        }
    }
}

export default UserSettings
